export type I18nLocale = 'en' | 'ko';
export type I18nFullLanguage = 'english' | 'korean';

export const localeToFull = (short: I18nLocale): I18nFullLanguage => {
  switch (short) {
    case 'en':
      return 'english';
    case 'ko':
      return 'korean';
    default:
      return 'korean';
  }
};
